module.exports = __webpack_public_path__ + "img/chefGrid.0bb8bef7.svg";